import { combineReducers } from 'redux';
import Session, { ISessionState } from './Session';
import Profile, { IProfileState } from './Profile';
import Report, { IReportState } from './Report/index';
import Account, { IAccountState } from './Account';
import Producer, { IProducerState } from './Producer';

export interface IStateApp {
		session: ISessionState,
		profile: IProfileState,
		report: IReportState,
		account: IAccountState,
		producer: IProducerState
}

const map = {
		session: Session,
		profile: Profile,
		report: Report,
		account: Account,
		producer: Producer
}

const reducers = combineReducers<IStateApp>(map as any);

export default reducers;
